import React, { useEffect, useState } from 'react'
import lodeingImg from "../Loder/loder.gif";
import { Link, useNavigate } from 'react-router-dom';
// import Dropdown from 'react-dropdown'; 
import 'react-dropdown/style.css';
import Modal from 'react-modal';
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from 'react-select';
import "./TodayNewJob.css"
import { IoMdClose } from "react-icons/io";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Dropdown from 'react-bootstrap/Dropdown';
import moment from 'moment';
import API_CONFIG from '../commonApi/ApiConfig';

const TableSkeleton = ({ columns }) => {
  return (
    <>
      {[...Array(10)].map((_, i) => (
        <tr key={i}>
          {[...Array(columns)].map((_, j) => (
            <td key={j} className="text-center align-middle">
              <div className="skeleton"></div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

const TableHeaderSkeleton = ({ columns }) => {
  return (
    <tr>
      {[...Array(columns)].map((_, j) => (
        <th key={j} className="text-center align-middle">
          <div className="skeleton" style={{ height: '20px', backgroundColor: 'rgba(255,255,255,0.3)' }}></div>
        </th>
      ))}
    </tr>
  );
};

const TodayJobs = () => {
  const [jobs, setJobs] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(10);
  const [ParentCategory, setParentCategory] = useState([])
  const [ParentCategoryGroup, setParentCategoryGroup] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const [totalJobs, setTotalJobs] = useState(0);
  const [allAddress, setallAddress] = useState([])
  const [StartDate, setStartDate] = useState(new Date().toISOString().split('T')[0])
  const [OrderId, setOrderId] = useState()
  const [EndDate, setEndDate] = useState(new Date().toISOString().split('T')[0])
  const [customerEmail, setcustomerEmail] = useState("");
  const [customername, setcustomername] = useState("");
  const [spname, setspname] = useState("")
  const [customermobileNo, setcustomermobileNo] = useState("")
  const [pageGroup, setPageGroup] = useState(0);
  const [couponCode, setcouponCode] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [isModalOpen4, setIsModalOpen4] = useState(false);
  const [isModalOpen5, setIsModalOpen5] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState("");
  const [AllSp, setAllSp] = useState([]);
  const [StatusJobs, setStatusJobs] = useState([])
  const [pcgs, setpcgs] = useState([]);
  const [slectedJob, setslectedJob] = useState();
  const [selectSlot, setselectSlot] = useState();
  const [DayFilter, setDayFilter] = useState(false)
  const [SlotData, setSlotData] = useState()
  const [SectTime, setSectTime] = useState("");
  const [JobLabel, setJobLabel] = useState("");
  const [totalJobsCount, settotalJobsCount] = useState(0)
  const [selectedContactNos, setSelectedContactNos] = useState([]);
  const [SerchLOcal, setSerchLOcal] = useState("")
  const [parPageLimit, setparPageLimit] = useState(50);

  const handleSelectChange = (selectedOptions) => {

    const contactNos = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setSelectedContactNos(contactNos);
    console.log(contactNos);
  };

  const handleSelectChange2 = (selectedOptions) => {
    const contactNos = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setStatusJobs(contactNos);
    console.log(contactNos);
  };
  const handleSelectChange3 = (selectedOptions) => {

    const contactNos = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setpcgs(contactNos);
    console.log(contactNos);
  };
  const [assignJobsdata, setassignJobsdata] = useState({
    jobId: null,
    action: null,
    reasons: null,
    jobAssignSProviderId: null,
    types: null,
    SPName: null,
    userId: null,
    slotDate: null,
    slotTime: null

  })
  const [Modellebal, setModellebal] = useState({
    label: "",
    value: ""
  })
  const pagesPerGroup = 6;
  const navigate = useNavigate()
  const jobStatuses = [
    { label: "Schedule", value: 0 },
    { label: "Open", value: 1 },
    { label: "Start Journey", value: 2 },
    { label: "Stop Journey", value: 3 },
    { label: "Progress", value: 4 },
    { label: "Pause", value: 5 },
    // { label: "Completed", value: 6 },
    { label: "Closed", value: 7 },
    { label: "Canceled", value: 9 },
    { label: "Cancel IR", value: 10 },
    { label: "Cancel CR", value: 11 },
    { label: "Cancel NR", value: 12 }
  ];

  const getGoldProfessionalFee = (jobItem) => {
    const goldCharge = jobItem?.otherCharges?.find(
      (item) => item?.charge === "Gold Professional Fee"
    );
    if (goldCharge && Number(goldCharge?.price) > 0) {
      return Number(goldCharge.price);
    }
    if (jobItem?.professionalType === "gold" && Number(jobItem?.professionalFee) > 0) {
      return Number(jobItem.professionalFee);
    }
    return 0;
  };

  const isGoldProfessionalJob = (jobItem) => {
    return (
      getGoldProfessionalFee(jobItem) > 0 ||
      jobItem?.professionalType === "gold" ||
      jobItem?.otherCharges?.some((item) => item?.charge === "Gold Professional Fee")
    );
  };

  // lst code
  const categorizeJobs = (jobs) => {
    const categorized = {
      morning: [],
      afternoon: [],
      evening: []
    };

    jobs.forEach(job => {
      const { slotTime } = job?.jobs?.[0] || {};

      if (slotTime) {
        const time = moment(slotTime, "hh:mm A");




        const is1130to12 =
          (time.format("hh") === "11" && time.minutes() >= 30 && time.format("A") === "AM") ||
          time.format("hh:mm A") === "12:00 PM";
        if (time.isSame(moment("11:30 PM", "hh:mm A"))) {
          categorized.morning.push(job);
          console.log("true time hai - this is between 11:30 AM and 12:00 PM", job);
          return;
        }

        if (is1130to12) {
          categorized.morning.push(job);
          return;

        }

        if (time.isBefore(moment("12:00 PM", "hh:mm A"))) {
          categorized.morning.push(job);
        } else if (time.isBefore(moment("02:30 PM", "hh:mm A"))) {
          categorized.afternoon.push(job);
        } else {
          categorized.evening.push(job);
        }
      }
    });

    // const sortDescending = (jobsArr) => {
    //   return jobsArr.sort((a, b) => {
    //     const timeA = moment(a.jobs[0].slotTime, "hh:mm A").valueOf();
    //     const timeB = moment(b.jobs[0].slotTime, "hh:mm A").valueOf();
    //     return timeA - timeB;
    //   });
    // };


    const sortDescending = (jobsArr) => {
      return jobsArr.sort((a, b) => {
        const timeA = moment(a.jobs[0].slotTime, "hh:mm A");
        const timeB = moment(b.jobs[0].slotTime, "hh:mm A");
        return timeA.valueOf() - timeB.valueOf();
      });
    };

    categorized.morning = sortDescending(categorized.morning);
    categorized.afternoon = sortDescending(categorized.afternoon);
    categorized.evening = sortDescending(categorized.evening);

    return categorized;
  };
  // lst code

  // const categorizeJobs = (jobs) => {
  //   const categorized = {
  //     morning: [],
  //     afternoon: [],
  //     evening: []
  //   };

  //   jobs.forEach(job => {
  //     const { slotTime } = job?.jobs?.[0] || {};

  //     if (slotTime) {
  //       const time = moment(slotTime, "hh:mm A");

  //       if (time.isBefore(moment("12:00 PM", "hh:mm A"))) {
  //         categorized.morning.push(job);
  //       } else if (time.isBefore(moment("02:30 PM", "hh:mm A"))) {
  //         categorized.afternoon.push(job);
  //       } else {
  //         categorized.evening.push(job);
  //       }
  //     }
  //   });

  //   const sortDescending = (jobsArr) => {
  //     return jobsArr.sort((a, b) => {
  //       const timeA = moment(a.jobs[0].slotTime, "hh:mm A").valueOf();
  //       const timeB = moment(b.jobs[0].slotTime, "hh:mm A").valueOf();
  //       return timeA - timeB;
  //     });
  //   };

  //   categorized.morning = sortDescending(categorized.morning);
  //   categorized.afternoon = sortDescending(categorized.afternoon);
  //   categorized.evening = sortDescending(categorized.evening);

  //   return categorized;
  // };
  // const categorizeJobs = (jobs) => {
  //   const categorized = {
  //     morning: [],
  //     afternoon: [],
  //     evening: []
  //   };

  //   jobs.forEach(job => {
  //     const { slotTime } = job?.jobs?.[0] || {};

  //     if (slotTime) {
  //       const time = moment(slotTime, "hh:mm A");


  //       if (time.isBefore(moment("12:00 PM", "hh:mm A"))) {
  //         categorized.morning.push(job);
  //       } else if (time.isBefore(moment("05:00 PM", "hh:mm A"))) {
  //         categorized.afternoon.push(job);
  //       } else {
  //         categorized.evening.push(job);
  //       }
  //     }
  //   });

  //   return categorized;
  // };



  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: "500px",
      height: "400px",
      overflow: "auto"
    },
  };

  const customStylesRes = {
    content: {
      position: 'absolute',
      border: '1px solid rgb(204, 204, 204)',
      background: 'rgb(255, 255, 255)',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      top: '60px',
      left: '50%',
      padding: '20px',
      transform: 'translate(-50%, 0%)',
      width: '100%',
      maxWidth: '85%',
      height: '100%',
      maxHeight: '90%',
    }
  }
  const customStyles2 = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: "500px",
      minheight: "100px",
      overflow: "auto"
    },
  };

  const getTodaysJobs = async (pagel) => {
    setLoading(true)
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        startDate: StartDate,
        endDate: EndDate,
        orderId: OrderId,
        customername: customername,
        spname: selectedContactNos,
        couponCode: couponCode,
        customeremailid: customerEmail,
        moboleno: customermobileNo,
        Status: StatusJobs,
        Parent_Category_Group: pcgs,
        DayFilter: DayFilter,
        parPageLimit: pagel || parPageLimit
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      const response = await fetch(`${API_CONFIG.JOB_GET_JOB_FI}?page=${currentPage}`, requestOptions)
      const result = await response.json()
      setJobs(result.data)
      setParentCategory(result?.ParentCategory)
      setParentCategoryGroup(result?.ParentCategoryGroup)
      setTotalPages(result?.totalPages)
      setTotalJobs(result?.totalJob);
      settotalJobsCount(result?.totalJobsCount);

      setallAddress(result?.address)

    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }


  const getSp = async () => {
    try {
      let ApiUrl = `${API_CONFIG.SERVICE_PROVIDER_API}/GetProviderByStatus`

      const getSp = await axios.get(ApiUrl)
      const result = getSp.data;
      setAllSp(result?.data)


    } catch (error) {
      console.error(error)

    }
  }

  const updateJobAssignment = async () => {
    try {
      const filteredData = Object.fromEntries(
        Object.entries(assignJobsdata).filter(([_, value]) => value !== undefined && value !== null)
      );

      const response = await fetch(API_CONFIG.JOB_UPDATE_ASSIGN, {
        method: "POST",
        headers: {
          "accept": "application/json, text/plain, */*",
          "authorization": `Bearer ${localStorage.getItem('token')}`,
          "content-type": "application/json"
        },
        body: JSON.stringify(filteredData),
      });

      const data = await response.json();
      getTodaysJobs();
      setassignJobsdata({

      })
      setIsModalOpen(false);
      setIsModalOpen2(false);
      setIsModalOpen3(false);
      setIsModalOpen4(false);
      setIsModalOpen5(false);

      Swal.fire("Success", `Job ${assignJobsdata?.action} successfully`, "success");
    } catch (error) {
      console.error("Error updating job:", error);
    }
  };

  useEffect(() => {
    getSp()
  }, [])


  const closeAllModal = () => {
    setIsModalOpen(false);
    setIsModalOpen2(false);
    setIsModalOpen3(false);
    setIsModalOpen4(false);
    setIsModalOpen5(false);
  }

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  useEffect(() => {
    getTodaysJobs()
  }, [currentPage])

  // Get current jobs for pagination

  // Change page

  // Format date and time
  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }


  const getTotalJobCount = (userId) => {
    const count = totalJobs?.filter(job => job?.userId === userId);
    // console.log(count.length,"jjjjj")
    return count.length
  }
  const handleNextGroup = () => {
    if ((pageGroup + 1) * pagesPerGroup < totalPages) {
      setPageGroup(pageGroup + 1);
    }
  };

  const handlePrevGroup = () => {
    if (pageGroup > 0) {
      setPageGroup(pageGroup - 1);
    }
  };

  const startPage = pageGroup * pagesPerGroup + 1;
  const endPage = Math.min(startPage + pagesPerGroup - 1, totalPages);

  const fetchSlots = async (date, PcatId) => {
    try {
      const response = await fetch(
        `${API_CONFIG.APPOINTMENT_SLOT_API}/SlotByParentId?date=${date}&PcatgroupId=${PcatId}`,
        {
          headers: {
            "accept": "application/json, text/plain, */*",
            "authorization": `Bearer ${localStorage.getItem('token')}`,
          },
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch slots");
      }



      const data = await response.json();
      setSlotData(data?.data);
      setIsModalOpen2(true);
    } catch (err) {
    }
  };


  const handleDropdownChange = (e, id, jobdata) => {

    if (e.value === 'editjob') {
      window.open(`/editjob/${id}`, '_blank')

    }
    if (e.value === 'duplicatejob') {
      window.open(`/duplicatejob/${id}`, '_blank')

    }
    if (e.value === 'assignsp') {
      openModal(id);
      setModellebal({
        label: jobdata?.jobs?.[0]?.jobStatus == 0 ? "Assign SP" : "Reassign SP",
        value: jobdata?.jobs?.[0]?.jobStatus == 0 ? "assigned" : "reassigned"
      })
      setassignJobsdata({
        ...assignJobsdata,
        action: jobdata?.jobs?.[0]?.jobStatus == 0 ? "assigned" : "reassigned",
        jobId: id,
        types: "admin",
        SPName: null,
        jobAssignSProviderId: null,
        userId: jobdata?.userData?._id,
        reasons: null
      })


    }
    if (e.value === 'reschedule') {
      fetchSlots(jobdata?.jobs?.[0]?.slotDate, jobdata?.jobs?.[0]?.cart?.[0]?.PCGroup);
      setslectedJob(jobdata);
      setselectSlot(jobdata?.jobs?.[0]?.slotDate);

      setassignJobsdata({
        ...assignJobsdata,
        action: "reschedule",
        jobId: id,
        types: "admin",
        userId: jobdata?.userData?._id,
        jobAssignSProviderId: jobdata?.serviceProviderData?._id,
        SPName: jobdata?.serviceProviderData?.name,
        slotDate: jobdata?.jobs?.[0]?.slotDate,
        reasons: null

      })

    }

    if (e.value === 'canceljob') {
      setIsModalOpen3(true)
      setassignJobsdata({
        ...assignJobsdata,
        action: "canceled",
        jobId: id,
        types: "admin",
        reasons: null

      })
    }
    if (e.value === 'start_journey') {
      setIsModalOpen4(true)
      setJobLabel("Start Journey")
      setassignJobsdata({
        ...assignJobsdata,
        action: "start_journey",
        jobId: id,
        types: "admin",
        reasons: null

      })





    }
    if (e.value === 'stop_journey') {
      setIsModalOpen4(true)
      setJobLabel("Stop Journey")

      setassignJobsdata({
        ...assignJobsdata,
        action: "stop_journey",
        jobId: id,
        types: "admin",
        reasons: null

      })





    }

    if (e.value == "start_job") {
      setIsModalOpen4(true)
      setJobLabel("Start Job")

      setassignJobsdata({
        ...assignJobsdata,
        action: "start_job",
        jobId: id,
        types: "admin",
        reasons: null

      })

    }
    if (e.value == "reopen") {
      setIsModalOpen4(true)
      setJobLabel("Reopen")

      setassignJobsdata({
        ...assignJobsdata,
        action: "reopen",
        jobId: id,
        types: "admin",
        jobAssignSProviderId: null,
        SPName: null,
        userId: jobdata?.userData?._id,
        reasons: null

      })

    }
    if (e.value == "stop_job") {
      setIsModalOpen4(true)
      setJobLabel("Stop Job")

      setassignJobsdata({
        ...assignJobsdata,
        action: "stop_job",
        jobId: id,
        types: "admin",
        reasons: null

      })

    }
    if (e.value == "resume_job") {
      setIsModalOpen4(true)
      setJobLabel("Resume Job")

      setassignJobsdata({
        ...assignJobsdata,
        action: "resume_job",
        jobId: id,
        types: "admin",
        reasons: null

      })

    }
    if (e.value == "close") {
      setIsModalOpen5(true)
      setslectedJob(jobdata);
      setassignJobsdata({
        ...assignJobsdata,
        action: "close",
        jobId: id,
        payableCharges: jobdata?.jobs?.[0]?.payableCharges,
        tip: 0,
        types: "admin",
        reasons: null

      })

    }


    setJobLabel(e?.label)

  }
  const openModal = (id) => {
    setSelectedJobId(id);
    setIsModalOpen(true);
    setModellebal({
      label: "Assign SP",
      value: "assignsp"
    })
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsModalOpen2(false);
    setModellebal({
      label: "Reshedule Job",
      value: "reshedule"
    })
  };
  const categorizedJobs = categorizeJobs(jobs);


  const exportToExcel = () => {
    // Prepare data for Excel
    const excelData = jobs.map((job, index) => ({
      "S.No.": currentPage > 1 ? parPageLimit * (currentPage - 1) + (index + 1) : index + 1,
      "Job ID": job?.jobs?.[0]?.jobId || '',
      "SP Name": job?.serviceProviderData?.Name || '',
      "Scheduled Date": job?.jobs?.[0]?.slotDate || '',
      "Scheduled Time": job?.jobs?.[0]?.slotTime || '',
      "Category": ParentCategoryGroup?.find((item) => item._id === job?.jobs?.[0].cart?.[0]?.PCGroup)?.PCGName || job?.jobs?.[0].cart?.[0]?.PCGroup || '',
      "Customer Name": job?.userData?.name || '',
      "Customer Email": job?.userData?.email || '',
      "Customer Mobile": job?.userData?.mobileNo || '',
      "Address": job?.jobs?.[0]?.userData?.address?.[0]?.FullAddress || '',
      "User Type": getTotalJobCount(job?.userData?._id) < 6 ? 'Silver' :
        getTotalJobCount(job?.userData?._id) < 15 ? 'Diamond' : 'Gold',
      "Job Count": getTotalJobCount(job?.userData?._id) || 0,
      "Job Status": getJobStatus(job?.jobs?.[0]?.jobStatus) || '',
    }));

    // Create a new workbook and worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs Data");

    // Convert to Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `Jobs_Data_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  // ... existing state and functions (getTodaysJobs, getSp, etc.) ...

// New function to fetch and export all data
const exportAllJobs = async () => {
  setLoading(true); // Show loading state while fetching all data
  try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      // Use the same filter parameters as getTodaysJobs, but omit 'page' and 'parPageLimit' 
      // OR pass a special indicator to the API to return ALL records.
      const raw = JSON.stringify({
          startDate: StartDate,
          endDate: EndDate,
          orderId: OrderId,
          customername: customername,
          spname: selectedContactNos,
          couponCode: couponCode,
          customeremailid: customerEmail,
          moboleno: customermobileNo,
          Status: StatusJobs,
          Parent_Category_Group: pcgs,
          DayFilter: DayFilter,
          
          // 💡 Crucial: Ask for a high limit (or a special 'all' flag) if the backend needs it.
          // If your API can return all data by omitting the page/limit, remove parPageLimit below.
          // If the API requires an explicit large number:
          parPageLimit: 10000, // Example: Set a very high limit
          // Note: If you add logic to the API to ignore pagination when 'page' is missing, 
          // you can often remove parPageLimit entirely from the request options for export.
      });

      const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
      };

      // 💡 Fetch data without the '?page=${currentPage}' parameter
      const response = await fetch(`${API_CONFIG.JOB_GET_JOB_FI}`, requestOptions);
      
      if (!response.ok) {
          throw new Error('Failed to fetch all jobs for export.');
      }

      const result = await response.json();
      const allJobsForExport = result.data; // Use the complete data array from the response

      // 2. Prepare data for Excel using the *allJobsForExport* array
      const excelData = allJobsForExport.map((job, index) => {
          const clientAddress =
            job?.jobs?.[0]?.userData?.address?.find(
              (addr) => addr?._id === job?.jobs?.[0]?.clientAddressId
            ) || job?.jobs?.[0]?.userData?.address?.[0];

          return {
          "S.No.": index + 1, // Reset serial number as this is the full list
          "Job ID": job?.jobs?.[0]?.jobId || '',
          "Customer Name": job?.userData?.name || '',
          "Customer Mobile": job?.userData?.mobileNo || '',
          "Customer Email": job?.userData?.email || '',
          "Customer Address": clientAddress?.FullAddress || '',
          "Customer City": clientAddress?.City || clientAddress?.city || '',
          "Socity/Apartment /building": clientAddress?.buildingName || clientAddress?.SaveAs || '',
          "Job Category": ParentCategoryGroup?.find((item) => item._id === job?.jobs?.[0].cart?.[0]?.PCGroup)?.PCGName || job?.jobs?.[0].cart?.[0]?.PCGroup || '',
          "Job Scheduled Date": job?.jobs?.[0]?.slotDate || '',
          "TimeSlot": job?.jobs?.[0]?.slotTime || '',
          "Regular Price": job?.jobs?.[0]?.RPrice || '',
          "Sell Price": job?.jobs?.[0]?.SPrice || '',
          "Coupon Applied": job?.jobs?.[0]?.couponCode || '',
          "Coupon Discount": job?.jobs?.[0]?.couponDiscount || '',  
          "Concession": job?.jobs?.[0]?.concession || '',
          "Wallet Amount":job?.jobs?.[0]?.WalletDataChekAmaunt || '',
          "Safety & Hygiene Kit":job?.jobs?.[0]?.otherCharges[0]?.charge || '',
          "Other Charges":job?.jobs?.[0]?.otherCharges[0]?.price || '',
          "Surge charges":job?.jobs?.[0]?.surgeCharges || '',
          "Payble Amount":job?.jobs?.[0]?.payableCharges || '',
          "SP Tip":job?.jobs?.[0]?.tip || '',
          "Penality":job?.jobs?.[0]?.jobPenalty || '',
          "Payment Mode":job?.jobs?.[0]?.payment_Mode || '',
          "Job Source":job?.jobs?.[0]?.jobsSource || '',
          "Job Status": getJobStatus(job?.jobs?.[0]?.jobStatus) || '',
          "SP Id": job?.serviceProviderData?._id || '',
          "SP Mobile": job?.serviceProviderData?.ContactNo || '',
          "Job Created Date": job?.jobs?.[0]?.createdAt || '',
        
          "SP Name": job?.serviceProviderData?.Name || '',
         
          // Ensure getTotalJobCount and getJobStatus are accessible/defined
          "User Type": getTotalJobCount(job?.userData?._id) < 6 ? 'Silver' :
              getTotalJobCount(job?.userData?._id) < 15 ? 'Diamond' : 'Gold',
          "Job Count": getTotalJobCount(job?.userData?._id) || 0,
      }});

      // 3. Create Excel file and trigger download
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs Data");

      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(data, `Jobs_Data_${new Date().toISOString().split('T')[0]}.xlsx`);

      Swal.fire("Success", "All filtered jobs have been exported.", "success");

  } catch (error) {
      console.error("Error exporting all jobs:", error);
      Swal.fire("Error", "Failed to export jobs. Please check the network or server response.", "error");
  } finally {
      setLoading(false); // Hide loading state
  }
};

// You need to rename the old function to the new one
// const exportToExcel = () => { ... } // <-- REMOVE THIS one.

  const getJobStatus = (status) => {
    const statusMap = {
      0: 'Schedule',
      1: 'Open',
      2: 'Start Journey',
      3: 'Stop Journey',
      4: 'Progress',
      5: 'Pause',
      6: 'Progress',
      7: 'Closed',
      9: 'Canceled',
      10: 'Cancel IR',
      11: 'Cancel CR',
      12: 'Cancel NR',
    };
    return statusMap[status] || 'Unknown';
  };
  let jobIds = [];

  const filteredJobs = jobs?.filter((job) => {
    jobIds.push(job?.jobs?.[0]?.jobId);
    const jobId = (typeof job?.jobs?.[0]?.jobId === 'string' ? job?.jobs?.[0]?.jobId.toLowerCase() : '');
    const spName = (typeof job?.serviceProviderData?.Name === 'string' ? job?.serviceProviderData?.Name.toLowerCase() : '');
    const spContact = (typeof job?.serviceProviderData?.ContactNo === 'string' ? job?.serviceProviderData?.ContactNo.toLowerCase() : '');
    const couponCode = (typeof job?.jobs?.[0]?.couponCode === 'string' ? job?.jobs?.[0]?.couponCode.toLowerCase() : '');
    const userName = (typeof job?.userData?.name === 'string' ? job?.userData?.name.toLowerCase() : '');
    const userEmail = (typeof job?.userData?.email === 'string' ? job?.userData?.email.toLowerCase() : '');
    const userMobile = (typeof job?.userData?.mobileNo === 'string' ? job?.userData?.mobileNo.toLowerCase() : '');
    const searchText = SerchLOcal?.toLowerCase();
    const addressMatch = job?.userData?.address?.some(address =>
      Object.values(address).some(value =>
        typeof value === 'string' && value.toLowerCase().includes(searchText)
      )
    );

    return (
      jobId.includes(searchText) ||
      spName.includes(searchText) ||
      spContact.includes(searchText) ||
      couponCode.includes(searchText) ||
      userName.includes(searchText) ||
      userEmail.includes(searchText) ||
      userMobile.includes(searchText) ||
      addressMatch
    );
  });




  return (
    <div className='pageinner ssssssss_ss'>
      <div className="container-fluid ">
        <div className="pb-0 pb-lg-3">
          <p class="lead mb-0"><span class="font-weight-bold">Today Jobs</span></p>
        </div>
        <div className='card  main-card '>
          <div className=''  >
            <div class="card-header py-0 p-0 px-3" id="headingOne"><h2 class="mb-0 py-3" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"><p class="card-title mb-0"><i class="fas fa-filter"></i> Filter</p></h2></div>
          </div>
          <div className="row mb-3 px-1 px-lg-3 data-card">
            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Select Date From</label>
              <input type="date" className="form-control" value={StartDate} onChange={(e) => setStartDate(e.target.value)} />
            </div>
            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Select Date To</label>
              <input type="date" className="form-control" value={EndDate} onChange={(e) => setEndDate(e.target.value)} />
            </div>

            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Parent Category Group</label>
              {/* <select style={{ width: "100%", padding: "0.5rem", borderRadius: "0.25rem", border: "1px solid #ccc" }} className="form-select"
              value={pcgs}
                onChange={(e) => setpcgs(e.target.value)}
              >
                <option value="">Select...</option>
                {ParentCategoryGroup?.map((group, index) => (
                  <option key={index} value={group?._id}>{group?.PCGName}</option>
                ))}
              </select> */}

              <Select
                isMulti
                value={pcgs.map(id => ({
                  value: id,
                  label: ParentCategoryGroup.find(item => item._id === id)?.PCGName
                }))}
                options={ParentCategoryGroup?.map(item => ({
                  value: item._id,
                  label: item.PCGName
                }))}
                onChange={handleSelectChange3}
              />
            </div>

            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Status</label>
              {/* <select style={{ width: "100%", padding: "0.5rem", borderRadius: "0.25rem", border: "1px solid #ccc" }} className="form-select"
              value={StatusJobs}
                onChange={(e) => setStatusJobs(e.target.value)}

              >
                <option value="">Select...</option>
                {
                  jobStatuses.map((status) => (
                    <option key={status.value} value={status.value}>{status.label}</option>
                  ))
                }
              </select> */}

              {/* <Select
                isMulti
             
                options={jobStatuses?.map(item => ({
                  value: item.value,
                  label: item.label
                }))}
                onChange={handleSelectChange2}
              /> */}


              <Select
                isMulti
                isClearable
                value={StatusJobs.map(id => ({
                  value: id,
                  label: jobStatuses.find(item => item.value === id)?.label
                }))}
                options={jobStatuses?.map(item => ({
                  value: item.value,
                  label: item.label
                }))}
                onChange={handleSelectChange2}
              />
            </div>

            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Order Id</label>
              <input type="text" className="form-control" placeholder='Order Id' value={OrderId} onChange={(e) => setOrderId(e.target.value)} />
            </div>
            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Customer Email Id</label>
              <input type="text" className="form-control" placeholder='Email Id' value={customerEmail} onChange={(e) => setcustomerEmail(e.target.value)} />
            </div>
            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Customer Mobile No</label>
              <input type="text" className="form-control" placeholder='Mobile No' value={customermobileNo} onChange={(e) => setcustomermobileNo(e.target.value)} />
            </div>
            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Customer Name</label>
              <input type="text" className="form-control" placeholder='Name' value={customername} onChange={(e) => setcustomername(e.target.value)} />
            </div>
            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">SP Mobile No</label>
              {/* <input type="text" className="form-control" placeholder='SP Name' value={spname} onChange={(e) => setspname(e.target.value)} /> */}

              <Select
                isMulti
                value={selectedContactNos.map(id => ({
                  value: id,
                  label: AllSp.find(item => item.ContactNo === id)?.Name
                }))}
                options={AllSp?.map(item => ({
                  value: item.ContactNo,
                  label: item.Name
                }))}
                onChange={handleSelectChange}
              />
            </div>
            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Coupon Code</label>
              <input type="text" className="form-control" placeholder='Coupon Code' value={couponCode} onChange={(e) => setcouponCode(e.target.value)} />
            </div>


            <div className="col-md-3 col-12 mt-2">
              <label className="form-label">Filter by day part</label>
              <select style={{ width: "100%", padding: "0.5rem", borderRadius: "0.25rem", border: "1px solid #ccc" }} className="form-select"
                value={DayFilter}

                onChange={(e) => { setDayFilter(JSON.parse(e.target.value)); }}
              >
                <option value={false}>Off</option>
                <option value={true}>Filter by day part</option>

              </select>
            </div>
          </div>


          <div>
            <div className="d-flex justify-content-center mb-2 mb-lg-4  " style={{ gap: "10px" }}>
              <button type="button" className="btn btn-primary me-2 px-4 px-lg-5" onClick={() => getTodaysJobs()}>
                <i className="fa fa-search mr-1"></i>
                <span className="d-none d-lg-inline-block">
                  Search
                </span>
              </button>
              <button
                onClick={exportAllJobs}
                type="button"
                className="btn btn-primary btn_export px-4 px-lg-5 "
              >
                <i className="fa fa-download"></i>{" "}
                <span className="d-none d-lg-inline-block">
                  Export
                </span>
              </button>
              <button type="button" className="btn btn-warning px-4 px-lg-5" onClick={() => {
                setStartDate("");
                setEndDate("");
                setPageGroup(0);
                setOrderId("");
                setcustomerEmail("");
                setcustomermobileNo("");
                setcustomername("");
                setcouponCode("");
                setSelectedContactNos([]);
                setCurrentPage(1);
                setDayFilter(false);
                setStatusJobs([]);
                setpcgs("");
                setSerchLOcal("");
                setSelectedContactNos([]);
                setpcgs([]);


              }}>

                <i className="fa fa-broom"></i>
                <span className="d-none d-lg-inline-block">
                  Clear
                </span>
              </button>
            </div>

          </div>
        </div>

            <div className='card teb-card '>
              <div className="card-header ">
                <div className="d-flex justify-content-between align-items-center slectgap teb-header ">
                  <div className='d-flex slectgap date-hend'>
                    <div>
                      <p className="card-title font-weight-bold lead mb-0">
                        Total Job :
                        <span className="total_jobs">{jobs?.length}/ {JSON.stringify(totalJobsCount)}</span>
                      </p>
                    </div>

                    <div>
                      <select class="form-select form-select-sm  ms-2 top-slect" aria-label=".form-select-sm example" onChange={(e) => {
                        setparPageLimit(e.target.value);
                        getTodaysJobs(e.target.value)
                      }} >
                        <option selected={parPageLimit == 10 ? true : false} value="10">10</option>
                        <option selected={parPageLimit == 20 ? true : false} value="20">20</option>
                        <option selected={parPageLimit == 30 ? true : false} value="30">30</option>
                        <option selected={parPageLimit == 40 ? true : false} value="40">40</option>
                        <option selected={parPageLimit == 50 ? true : false} value="50">50</option>
                      </select>
                    </div>
                  </div>
                  <div className="add-start">


                    <Link
                      to={"/createjob"}
                      className="btn btn-info btn-sm "
                    >
                      <i className="fas fa-plus-circle"></i> New Job
                    </Link>
                  </div>
                </div>
              </div>

              <div className="" >
                <div className="mb-2 d-flex justify-content-end mt-2  mb-lg-3 search-boxx" >
                  <div>
                    <input
                      type="text"
                      placeholder="Search..."
                      value={SerchLOcal}
                      onChange={(e) => setSerchLOcal(e.target.value)}
                      className="form-control searchimp"
                    />
                  </div>
                </div>
                {DayFilter == false || DayFilter == "false" ?
                  <table className="table table-striped table-hover table-bordered" style={{ width: "100%", overflowX: "scroll", display: "inline-block" }}>

                    <thead className="bg-primary text-white table_head">
                      {loading ? (
                        <TableHeaderSkeleton columns={9} />
                      ) : (
                        <tr>
                          <th scope="col">S.No.</th>
                          <th scope="col" className='text-center' >Job ID</th>
                          <th scope="col" className='text-center' >SP Name</th>
                          <th scope="col" className='text-center' >Scheduled Date & Time</th>
                          <th scope="col" className='text-center' >Category</th>
                          <th scope="col" className='text-center' >Customer</th>
                          <th scope="col" className='text-center addresth ' >Address</th>
                          <th scope="col" className='text-center' >User Type</th>
                          <th scope="col" className='text-center' >Action</th>
                        </tr>
                      )}
                    </thead>
                    <tbody className='job-table-body_main' >
                      {loading ? (
                        <TableSkeleton columns={9} />
                      ) : (
                        filteredJobs?.map((job, index) => (
                        <tr key={job._id}
                        >
                          <td style={{ cursor: "pointer" }} onClick={() => window.open(`/jobdetails/${job?.jobs?.[0]?.jobId}`)}>{currentPage > 1 ? parPageLimit * (currentPage - 1) + (index + 1) : index + 1}</td>
                          <td className='text-center align-middle' >
                            <span className="d-block mb-1 jobID fs-6 text-primary relative" style={{ fontSize: "16px", letterSpacing: "1px", cursor: " pointer" }} onClick={() => window.open(`/jobdetails/${job?.jobs?.[0]?.jobId}`)}>
                              {job?.jobs?.[0]?.jobId}

                              {
                                job?.jobs?.[0]?.cart?.[0]?.packageName?.length > 0 ?

                                  // <span className="package-name" >{job?.jobs?.[0]?.cart?.[0]?.packageName?.map((item) => item)}</span>
                                  <span className="package-name" >
                                    {job?.jobs?.[0]?.cart?.map((item, index) => {
                                      return (
                                        <tr>
                                          <td>{index + 1}</td>
                                          <td>
                                            <span
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: 600,
                                              }}
                                            >
                                              {item?.packageTitle}
                                            </span>
                                            <ul
                                              className="ml-1"
                                              style={{
                                                fontSize: "14px",
                                              }}
                                            >
                                              {item?.packageName &&
                                                item?.packageName.map(
                                                  (item, index) => {
                                                    return (
                                                      <li className="mb-0">
                                                        {item}
                                                      </li>
                                                    );
                                                  }
                                                )}
                                            </ul>
                                          </td>
                                          <td>{item?.Quantity}</td>
                                          <td>
                                            ₹ {item?.packagetotalPrice}
                                          </td>
                                          <td>₹ {item?.Amount}</td>
                                        </tr>
                                      );
                                    })}
                                  </span>
                                  :
                                  // <span className="package-name" >{job?.jobs?.[0]?.cart?.[0]?.packageTitle}</span>
                                  <span className="package-name" >
                                    {job?.jobs?.[0]?.cart?.map((item, index) => {
                                      return (
                                        <tr>
                                          <td>{index + 1}</td>
                                          <td>
                                            <span
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: 600,
                                              }}
                                            >
                                              {item?.packageTitle}
                                            </span>
                                            <ul
                                              className="ml-1"
                                              style={{
                                                fontSize: "14px",
                                              }}
                                            >
                                              {item?.packageName &&
                                                item?.packageName.map(
                                                  (item, index) => {
                                                    return (
                                                      <li className="mb-0">
                                                        {item}
                                                      </li>
                                                    );
                                                  }
                                                )}
                                            </ul>
                                          </td>
                                          <td>{item?.Quantity}</td>
                                          <td>
                                            ₹ {item?.packagetotalPrice}
                                          </td>
                                          <td>₹ {item?.Amount}</td>
                                        </tr>
                                      );
                                    })}
                                  </span>

                              }

                            </span>

                            {job?.jobs?.[0]?.jobStatus == 0 && (
                              <label className="badge badge-primary">
                                Schedule
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 1 && (
                              <label className="badge badge-primary">
                                Open
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 2 && (
                              <label className="badge badge-warning">
                                Start Journey
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 3 && (
                              <label className="badge badge-warning">
                                Stop Journey
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 4 && (
                              <label className="badge badge-primary progressBtn">
                                Progress
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 5 && (
                              <label className="badge badge-primary pauseBtn">
                                Pause
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 6 && (
                              <label className="badge badge-primary progressBtn ">
                                Progress
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 7 && (
                              <label className="badge badge-primary successBtn">
                                Closed
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 9 && (
                              <label className="badge badge-primary pauseBtn">
                                Canceled
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 10 && (
                              <label className="badge badge-primary pauseBtn">
                                Cancel IR
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 11 && (
                              <label className="badge badge-primary pauseBtn">
                                Cancel CR
                              </label>
                            )}
                            {job?.jobs?.[0]?.jobStatus == 12 && (
                              <label className="badge badge-primary pauseBtn">
                                Cancel NR
                              </label>
                            )}

                            {job?.jobs?.[0]?.Note?.length > 0 &&
                              <div
                                className="jobNotesBox"
                                style={{
                                  position: "relative",
                                  top: "0",
                                  right: "50%",
                                  left: "34%",
                                }}
                              >
                                <span class="icon--inventory"></span>
                                <div className="card card-body jobNotes">
                                  <p className="d-flex justify-content-between align-items-center">
                                    <span>{job?.jobs?.[0]?.Note}</span>


                                  </p>
                                </div>
                              </div>
                            }

                            {job?.jobs?.[0]?.updateLogs?.filter((itemDataf) => itemDataf.action == "Jobnotes")?.length > 0 &&
                              <div
                                className="jobNotesBox"
                                style={{
                                  position: "relative",
                                  top: "0",
                                  right: "50%",
                                  left: "34%",
                                }}
                              >
                                <span class="icon--inventory"></span>
                                <div className="card card-body jobNotes">
                                  <p className="d-flex justify-content-between align-items-center">
                                    <span>
                                      {job?.jobs?.[0]?.updateLogs?.filter((itemDataf) => itemDataf.action == "Jobnotes")?.map((itemData, indexs) => {
                                        return (
                                          <p className="d-flex justify-content-between align-items-center">
                                            <span className='pop_se'>
                                              {indexs + 1}
                                              {". "}
                                              {itemData.reason}
                                            </span>
                                            <span></span>
                                            <small className=''>
                                              {new Date(itemData?.updatedAt).toLocaleDateString()}
                                              &nbsp;
                                              &nbsp;
                                              {new Date(itemData?.updatedAt).toLocaleTimeString()}
                                              {/* {datePart} &nbsp;
                                  &nbsp;
                                  {timePart} */}
                                            </small>
                                          </p>
                                        )
                                      })}


                                    </span>


                                  </p>
                                </div>
                              </div>
                            }



                          </td>

                          <td className='align-middle text-center' >
                            <span className='d-block mb-1'>
                              {job?.serviceProviderData?.Name || ''}

                            </span>
                            <a class="text-nowrap" href={`tel:${job?.serviceProviderData?.ContactNo}`}>
                              {job?.serviceProviderData?.Name && <i class="fas fa-phone"></i>}

                              {job?.serviceProviderData?.ContactNo}
                            </a>
                            {/* <span className='d-block text-center'>
                            {job?.serviceProviderData?.ContactNo}

                          </span> */}

                          </td>
                          <td className='text-center align-middle'>
                            <p className='text-center m-0'>

                              {job?.jobs?.[0]?.slotDate}
                            </p>
                            <p className='badge badge-primary mb-1 font-fixd   ' >{job?.jobs?.[0]?.slotTime}</p>
                          </td>
                          <td className='align-middle text-center' style={{ whiteSpace: 'nowrap' }}>
                            {
                              job?.jobs?.[0]?.couponCode &&
                              <p
                                className='badge badge-danger PauseBtn mb-4'
                                style={{ backgroundColor: "red", fontSize: "12px" }}

                              >  {job?.jobs?.[0]?.couponCode}</p>
                            }

                            <p className='badge badge-success ml-1 mb-2  d-block' style={{ fontSize: '12px', }}> {ParentCategoryGroup?.find((item) => item._id === job?.jobs?.[0].cart?.[0]?.PCGroup)?.PCGName || job?.jobs?.[0].cart?.[0]?.PCGroup} </p>
                            {isGoldProfessionalJob(job?.jobs?.[0]) && (
                              <p className='badge badge-warning ml-1 mb-0 d-block' style={{ fontSize: '12px' }}>
                                Gold Expert{getGoldProfessionalFee(job?.jobs?.[0]) > 0 ? ` (+₹${getGoldProfessionalFee(job?.jobs?.[0])})` : ""}
                              </p>
                            )}
                          </td>
                          <td className='align-middle text-center'>


                            <span class="d-block text-center">{job?.userData?.name}</span>
                            <span class="d-block text-center">{job?.userData?.email}</span>
                            <span class="d-block text-center"><a href={`tel:${job?.userData?.mobileNo}`} class="text-dark text-center"><i class="fa fa-phone mr-2"></i>{job?.userData?.mobileNo}</a></span>
                          </td>
                          <td className='align-middle text-center' style={{ minWidth: "200px" }} >
                            <div>
                              <a
                                className="text-dark"
                                href={
                                  job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress != null && job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress != "" ?
                                    `https://www.google.com/maps/search/?api=1&query=` + encodeURI(
                                      job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress
                                    ) : `https://www.google.com/maps?q=${job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.location?.latitude},${job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.location?.longitude}`}

                                target="_blank"
                              >


                                <span className='d-block text-center font-weight-bold '>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.SaveAs}</span>
                                <span className='d-block text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.houseOrFlatNo}</span>
                                <span className='d-block text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.buildingName}</span>
                                <span className='d-block  text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.landmark}</span>

                                <span className='d-block text-center'> <i class="fa fa-map-marker mr-2 display-inline-block"></i>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress}</span>
                              </a>
                            </div>
                          </td>
                          <td className='align-middle text-center'>


                            {
                              getTotalJobCount(job?.userData?._id) < 6 && (
                                <span
                                  style={{
                                    backgroundColor:
                                      "#cbcfd6",
                                  }}
                                  className="badge badge-light mb-0 d-block"

                                >Silver</span>
                              )
                            }
                            {
                              getTotalJobCount(job?.userData?._id) >= 6 && getTotalJobCount(job?.userData?._id) < 15 && (
                                <span className="badge badge-info mb-2 d-block ">Diamond</span>
                              )
                            }
                            {
                              getTotalJobCount(job?.userData?._id) >= 15 && (
                                <span className="badge badge-warning mb-2 d-block ">Gold</span>
                              )
                            }
                            <span className='d-flex   ' style={{ whiteSpace: 'nowrap', gap: "5px" }}>
                              <p>

                                R. Count :
                              </p>
                              <p>

                                {job?.jobs?.[0]?.updateLogs?.filter((itemDtaa) => itemDtaa?.action == "reschedule")?.length
                                }
                                <br></br>

                              </p>
                            </span>
                            <span className='d-flex   ' style={{ whiteSpace: 'nowrap', gap: "5px" }}>
                              <p>

                                Job Count:
                              </p>
                              <p>

                                {getTotalJobCount(job?.userData?._id)}
                                <br></br>

                              </p>
                            </span>
                          </td>
                          <td className='align-middle ' style={{ whiteSpace: 'nowrap' }}>



                            {/* <Dropdown
                              options={[
                                {
                                  value: 'editjob', label: (
                                    <span>
                                      <i className="fas fa-edit"></i> Edit Job
                                    </span>
                                  )
                                },

                                { value: 'assignsp', label: job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>) },
                                { value: 'reschedule', label: <><i className="fa fa-user-edit mr-1"></i>Reschedule Job</> },
                                { value: 'canceljob', label: job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null },
                                { value: "start_journey", label: job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null },
                                { value: "stop_journey", label: job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null },
                                { value: "start_job", label: job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null },
                                { value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null },
                                { value: "resume_job", label: job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null },
                                { value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null },
                                { value: "close", label: job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null },
                                { value: "reopen", label: job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null },
                                { value: "duplicatejob", label: <span><i class="fas fa-clone"></i> Duplicate Job</span> }
                              ].filter(option => option.label)}
                              onChange={(e) => {
                                handleDropdownChange(e, job?.jobs?.[0]?.jobId, job);
                              }}
                              placeholder="Action"
                              arrowClosed={<span className="arrow-closed" />}
                              arrowOpen={<span className="arrow-open" />}
                              style={{ whiteSpace: 'nowrap' }}
                            /> */}


                            <Dropdown>
                              <Dropdown.Toggle variant="transparent" id="dropdown-basic" className='border-1 border-dark'>
                                Action
                              </Dropdown.Toggle>

                              <Dropdown.Menu>

                                {
                                  job?.jobs?.[0]?.jobStatus != 9 &&


                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({
                                      value: 'editjob', label: (
                                        <span>
                                          <i className="fas fa-edit"></i> Edit Job
                                        </span>
                                      )
                                    }, job?.jobs?.[0]?.jobId, job);
                                  }}  >
                                    <span>
                                      <i className="fas fa-edit"></i> Edit Job
                                    </span>

                                  </Dropdown.Item>
                                }
                                {job?.jobs?.[0]?.jobStatus != 7 && job?.jobs?.[0]?.jobStatus != 9 && (<Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: 'assignsp', label: job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>) }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus != 7 && job?.jobs?.[0]?.jobStatus != 9 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>)} </Dropdown.Item>)}
                                {
                                  job?.jobs?.[0]?.jobStatus != 9 &&


                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'reschedule', label: <><i className="fa fa-user-edit mr-1"></i>Reschedule Job</> }, job?.jobs?.[0]?.jobId, job);
                                  }}> {<><i className="fa fa-user-edit mr-1"></i>Reschedule Job</>} </Dropdown.Item>
                                }
                                {job?.jobs?.[0]?.jobStatus != 9 && job?.jobs?.[0]?.jobStatus != 10 && job?.jobs?.[0]?.jobStatus != 11 && job?.jobs?.[0]?.jobStatus != 7 && job?.jobs?.[0]?.jobStatus != 12 ? <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: 'canceljob', label: job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null} </Dropdown.Item> : null}
                                {job?.jobs?.[0]?.jobStatus === 1 ? <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: "start_journey", label: job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null} </Dropdown.Item> : null}
                                {job?.jobs?.[0]?.jobStatus === 2 ? <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: "stop_journey", label: job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null} </Dropdown.Item> : null}
                                {job?.jobs?.[0]?.jobStatus === 3 ? <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: "start_job", label: job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null} </Dropdown.Item> : null}
                                {job?.jobs?.[0]?.jobStatus === 4 ? <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null} </Dropdown.Item> : null}
                                {job?.jobs?.[0]?.jobStatus === 5 ? <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: "resume_job", label: job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null} </Dropdown.Item> : null}
                                {job?.jobs?.[0]?.jobStatus === 6 ? <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null} </Dropdown.Item> : null}
                                {job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 && job?.jobs?.[0]?.jobStatus != 9 ? <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: "close", label: job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null} </Dropdown.Item> : null}
                                {job?.jobs?.[0]?.jobStatus === 7 ? <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: "reopen", label: job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null }, job?.jobs?.[0]?.jobId, job);
                                }}> {job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null} </Dropdown.Item> : null}
                                <Dropdown.Item onClick={() => {
                                  handleDropdownChange({ value: "duplicatejob", label: <span><i class="fas fa-clone"></i> Duplicate Job</span> }, job?.jobs?.[0]?.jobId, job);
                                }}> {<span><i class="fas fa-clone"></i> Duplicate Job</span>} </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>


                          </td>
                        </tr>
                      )))}
                    </tbody>
                  </table> :
                  <>
                    <table className="table table-striped table-hover table-bordered" style={{ width: "100%", overflowX: "scroll", display: "inline-block" }}>
                      <thead className="bg-primary text-white table_head">
                        {loading ? (
                          <TableHeaderSkeleton columns={9} />
                        ) : (
                          <tr>
                            <th scope="col">S.No.</th>
                            <th scope="col">Job ID</th>
                            <th scope="col">SP Name</th>
                            <th scope="col" style={{ whiteSpace: 'nowrap' }}>Scheduled Date & Time</th>
                            <th scope="col">Category</th>
                            <th scope="col">Customer</th>
                            <th scope="col">Address</th>
                            <th scope="col">User Type</th>
                            <th scope="col">Action</th>
                          </tr>
                        )}
                      </thead>
                      <tbody >
                        {loading ? (
                          <TableSkeleton columns={9} />
                        ) : (
                          <>
                            <tr>
                          <p className="m-0 p-2 text-primary font-weight-bold">Morning</p>
                        </tr>
                        {categorizedJobs["morning"]?.map((job, index) => (
                          <tr key={job._id}  >
                            <td style={{ cursor: "pointer" }} onClick={() => window.open(`/jobdetails/${job?.jobs?.[0]?.jobId}`)}>{currentPage > 1 ? parPageLimit * (currentPage - 1) + (index + 1) : index + 1}</td>
                            <td className='text-center align-middle' >
                              <span className="d-block mb-1 jobID fs-6 text-primary relative" style={{ fontSize: "16px", letterSpacing: "1px", cursor: " pointer" }} onClick={() => window.open(`/jobdetails/${job?.jobs?.[0]?.jobId}`)}>
                                {job?.jobs?.[0]?.jobId}

                                {
                                  job?.jobs?.[0]?.cart?.[0]?.packageName?.length > 0 ?

                                    <span className="package-name" >
                                      {job?.jobs?.[0]?.cart?.map((item, index) => {
                                        return (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                              <span
                                                style={{
                                                  fontSize: "15px",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                {item?.packageTitle}
                                              </span>
                                              <ul
                                                className="ml-1"
                                                style={{
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {item?.packageName &&
                                                  item?.packageName.map(
                                                    (item, index) => {
                                                      return (
                                                        <li className="mb-0">
                                                          {item}
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                              </ul>
                                            </td>
                                            <td>{item?.Quantity}</td>
                                            <td>
                                              ₹ {item?.packagetotalPrice}
                                            </td>
                                            <td>₹ {item?.Amount}</td>
                                          </tr>
                                        );
                                      })}
                                    </span>
                                    :
                                    <span className="package-name" >
                                      {job?.jobs?.[0]?.cart?.map((item, index) => {
                                        return (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                              <span
                                                style={{
                                                  fontSize: "15px",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                {item?.packageTitle}
                                              </span>
                                              <ul
                                                className="ml-1"
                                                style={{
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {item?.packageName &&
                                                  item?.packageName.map(
                                                    (item, index) => {
                                                      return (
                                                        <li className="mb-0">
                                                          {item}
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                              </ul>
                                            </td>
                                            <td>{item?.Quantity}</td>
                                            <td>
                                              ₹ {item?.packagetotalPrice}
                                            </td>
                                            <td>₹ {item?.Amount}</td>
                                          </tr>
                                        );
                                      })}
                                    </span>

                                }
                              </span>

                              {job?.jobs?.[0]?.jobStatus == 0 && (
                                <label className="badge badge-primary">
                                  Schedule
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 1 && (
                                <label className="badge badge-primary">
                                  Open
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 2 && (
                                <label className="badge badge-warning">
                                  Start Journey
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 3 && (
                                <label className="badge badge-warning">
                                  Stop Journey
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 4 && (
                                <label className="badge badge-primary progressBtn">
                                  Progress
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 5 && (
                                <label className="badge badge-primary pauseBtn">
                                  Pause
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 6 && (
                                <label className="badge badge-primary progressBtn ">
                                  Progress
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 7 && (
                                <label className="badge badge-primary successBtn">
                                  Closed
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 9 && (
                                <label className="badge badge-primary pauseBtn">
                                  Canceled
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 10 && (
                                <label className="badge badge-primary pauseBtn">
                                  Cancel IR
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 11 && (
                                <label className="badge badge-primary pauseBtn">
                                  Cancel CR
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 12 && (
                                <label className="badge badge-primary pauseBtn">
                                  Cancel NR
                                </label>
                              )}

                              {job?.jobs?.[0]?.Note?.length > 0 &&
                                <div
                                  className="jobNotesBox"
                                  style={{
                                    position: "relative",
                                    top: "0",
                                    right: "50%",
                                    left: "34%",
                                  }}
                                >
                                  <span class="icon--inventory"></span>
                                  <div className="card card-body jobNotes">
                                    <p className="d-flex justify-content-between align-items-center">
                                      <span>{job?.jobs?.[0]?.Note}</span>


                                    </p>
                                  </div>
                                </div>
                              }



                            </td>

                            <td className='align-middle text-center' >
                              <span className='d-block mb-1'>
                                {job?.serviceProviderData?.Name || ''}

                              </span>
                              <a class="text-nowrap" href={`tel:${job?.serviceProviderData?.ContactNo}`}>
                                {job?.serviceProviderData?.Name && <i class="fas fa-phone"></i>}
                                {job?.serviceProviderData?.ContactNo}</a>
                              {/* <span className='d-block text-center'>
                            {job?.serviceProviderData?.ContactNo}

                          </span> */}

                            </td>
                            <td className='text-center align-middle'>
                              <p className='text-center m-0'>

                                {job?.jobs?.[0]?.slotDate}
                              </p>
                              <p className='badge badge-primary mb-1 font-fixd   ' >{job?.jobs?.[0]?.slotTime}</p>
                            </td>
                            <td className='align-middle text-center' style={{ whiteSpace: 'nowrap' }}>
                              {
                                job?.jobs?.[0]?.couponCode &&
                                <p
                                  className='badge badge-danger PauseBtn mb-4'
                                  style={{ backgroundColor: "red", fontSize: "12px" }}

                                >  {job?.jobs?.[0]?.couponCode}</p>
                              }

                              <p className='badge badge-success ml-1 mb-2  d-block' style={{ fontSize: '12px', }}> {ParentCategoryGroup?.find((item) => item._id === job?.jobs?.[0].cart?.[0]?.PCGroup)?.PCGName || job?.jobs?.[0].cart?.[0]?.PCGroup} </p>
                              {isGoldProfessionalJob(job?.jobs?.[0]) && (
                                <p className='badge badge-warning ml-1 mb-0 d-block' style={{ fontSize: '12px' }}>
                                  Gold Expert{getGoldProfessionalFee(job?.jobs?.[0]) > 0 ? ` (+₹${getGoldProfessionalFee(job?.jobs?.[0])})` : ""}
                                </p>
                              )}
                            </td>
                            <td className='align-middle text-center'>


                              <span class="d-block text-center">{job?.userData?.name}</span>
                              <span class="d-block text-center">{job?.userData?.email}</span>
                              <span class="d-block text-center"><a href="tel:9958887022" class="text-dark text-center"><i class="fa fa-phone mr-2"></i>{job?.userData?.mobileNo}</a></span>
                            </td>


                            <td className='align-middle text-center' style={{ minWidth: "200px" }} >
                              <div>
                                <a
                                  className="text-dark"
                                  href={
                                    job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress != null && job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress != "" ?
                                      `https://www.google.com/maps/search/?api=1&query=` + encodeURI(
                                        job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress
                                      ) : `https://www.google.com/maps?q=${job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.location?.latitude},${job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.location?.longitude}`}

                                  target="_blank"
                                >


                                  <span className='d-block text-center font-weight-bold '>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.SaveAs}</span>
                                  <span className='d-block text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.houseOrFlatNo}</span>

                                  <span className='d-block text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.buildingName}</span>
                                  <span className='d-block  text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.landmark}</span>

                                  <span className='d-block text-center'> <i class="fa fa-map-marker mr-2 display-inline-block"></i>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress}</span>
                                </a>
                              </div>
                            </td>
                            <td className='align-middle text-center'>


                              {
                                getTotalJobCount(job?.userData?._id) < 6 && (
                                  <span
                                    style={{
                                      backgroundColor:
                                        "#cbcfd6",
                                    }}
                                    className="badge badge-light mb-0 d-block"

                                  >Silver</span>
                                )
                              }
                              {
                                getTotalJobCount(job?.userData?._id) >= 6 && getTotalJobCount(job?.userData?._id) < 15 && (
                                  <span className="badge badge-info mb-2 d-block ">Diamond</span>
                                )
                              }
                              {
                                getTotalJobCount(job?.userData?._id) >= 15 && (
                                  <span className="badge badge-warning mb-2 d-block ">Gold</span>
                                )
                              }
                              <span className='d-flex   ' style={{ whiteSpace: 'nowrap', gap: "5px" }}>
                                <p>

                                  R. Count :
                                </p>
                                <p>

                                  {job?.jobs?.[0]?.updateLogs?.filter((itemDtaa) => itemDtaa?.action == "reschedule")?.length
                                  }
                                  <br></br>

                                </p>
                              </span>
                              <span className='d-flex   ' style={{ whiteSpace: 'nowrap', gap: "5px" }}>
                                <p>

                                  Job Count:
                                </p>
                                <p>

                                  {getTotalJobCount(job?.userData?._id)}
                                  <br></br>

                                </p>
                              </span>
                            </td>
                            <td className='align-middle ' style={{ whiteSpace: 'nowrap' }}>



                              {/* <Dropdown
                                options={[
                                  {
                                    value: 'editjob', label: (
                                      <span>
                                        <i className="fas fa-edit"></i> Edit Job
                                      </span>
                                    )
                                  },

                                  { value: 'assignsp', label: job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>) },
                                  { value: 'reschedule', label: <><i className="fa fa-user-edit mr-1"></i>Reschedule Job</> },
                                  { value: 'canceljob', label: job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null },
                                  { value: "start_journey", label: job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null },
                                  { value: "stop_journey", label: job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null },
                                  { value: "start_job", label: job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null },
                                  { value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null },
                                  { value: "resume_job", label: job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null },
                                  { value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null },
                                  { value: "close", label: job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null },
                                  { value: "reopen", label: job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null },
                                  { value: "duplicatejob", label: <span><i class="fas fa-clone"></i> Duplicate Job</span> }
                                ].filter(option => option.label)}
                                onChange={(e) => {
                                  handleDropdownChange(e, job?.jobs?.[0]?.jobId, job);
                                }}
                                placeholder="Action"
                                arrowClosed={<span className="arrow-closed" />}
                                arrowOpen={<span className="arrow-open" />}
                                style={{ whiteSpace: 'nowrap' }}
                              /> */}
                              <Dropdown>
                                <Dropdown.Toggle variant="transparent" id="dropdown-basic" className='border-1 border-dark'>
                                  Action
                                </Dropdown.Toggle>

                                <Dropdown.Menu>

                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({
                                      value: 'editjob', label: (
                                        <span>
                                          <i className="fas fa-edit"></i> Edit Job
                                        </span>
                                      )
                                    }, job?.jobs?.[0]?.jobId, job);
                                  }}  >
                                    <span>
                                      <i className="fas fa-edit"></i> Edit Job
                                    </span>

                                  </Dropdown.Item>

                                  {job?.jobs?.[0]?.jobStatus != 7 && (<Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'assignsp', label: job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>) }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>)} </Dropdown.Item>)}
                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'reschedule', label: <><i className="fa fa-user-edit mr-1"></i>Reschedule Job</> }, job?.jobs?.[0]?.jobId, job);
                                  }}> {<><i className="fa fa-user-edit mr-1"></i>Reschedule Job</>} </Dropdown.Item>
                                  {job?.jobs?.[0]?.jobStatus != 7 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'canceljob', label: job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 1 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "start_journey", label: job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 2 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "stop_journey", label: job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 3 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "start_job", label: job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 4 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 5 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "resume_job", label: job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 6 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "close", label: job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 7 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "reopen", label: job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null} </Dropdown.Item> : null}
                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "duplicatejob", label: <span><i class="fas fa-clone"></i> Duplicate Job</span> }, job?.jobs?.[0]?.jobId, job);
                                  }}> {<span><i class="fas fa-clone"></i> Duplicate Job</span>} </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>

                            </td>
                          </tr>
                        ))}
                        <tr>
                          <p className="m-0 p-2 text-primary font-weight-bold">Afternoon</p>
                        </tr>
                        {categorizedJobs["afternoon"]?.map((job, index) => (
                          <tr key={job._id}  >
                            <td style={{ cursor: "pointer" }} onClick={() => window.open(`/jobdetails/${job?.jobs?.[0]?.jobId}`)}>{categorizedJobs["morning"].length + index + 1}</td>
                            <td className='text-center align-middle' >
                              <span className="d-block mb-1 jobID fs-6 text-primary relative" style={{ fontSize: "16px", letterSpacing: "1px", cursor: " pointer" }} onClick={() => window.open(`/jobdetails/${job?.jobs?.[0]?.jobId}`)}>
                                {job?.jobs?.[0]?.jobId}

                                {
                                  job?.jobs?.[0]?.cart?.[0]?.packageName?.length > 0 ?

                                    <span className="package-name" >
                                      {job?.jobs?.[0]?.cart?.map((item, index) => {
                                        return (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                              <span
                                                style={{
                                                  fontSize: "15px",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                {item?.packageTitle}
                                              </span>
                                              <ul
                                                className="ml-1"
                                                style={{
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {item?.packageName &&
                                                  item?.packageName.map(
                                                    (item, index) => {
                                                      return (
                                                        <li className="mb-0">
                                                          {item}
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                              </ul>
                                            </td>
                                            <td>{item?.Quantity}</td>
                                            <td>
                                              ₹ {item?.packagetotalPrice}
                                            </td>
                                            <td>₹ {item?.Amount}</td>
                                          </tr>
                                        );
                                      })}
                                    </span>
                                    :
                                    <span className="package-name" >
                                      {job?.jobs?.[0]?.cart?.map((item, index) => {
                                        return (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                              <span
                                                style={{
                                                  fontSize: "15px",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                {item?.packageTitle}
                                              </span>
                                              <ul
                                                className="ml-1"
                                                style={{
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {item?.packageName &&
                                                  item?.packageName.map(
                                                    (item, index) => {
                                                      return (
                                                        <li className="mb-0">
                                                          {item}
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                              </ul>
                                            </td>
                                            <td>{item?.Quantity}</td>
                                            <td>
                                              ₹ {item?.packagetotalPrice}
                                            </td>
                                            <td>₹ {item?.Amount}</td>
                                          </tr>
                                        );
                                      })}
                                    </span>

                                }
                              </span>

                              {job?.jobs?.[0]?.jobStatus == 0 && (
                                <label className="badge badge-primary">
                                  Schedule
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 1 && (
                                <label className="badge badge-primary">
                                  Open
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 2 && (
                                <label className="badge badge-warning">
                                  Start Journey
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 3 && (
                                <label className="badge badge-warning">
                                  Stop Journey
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 4 && (
                                <label className="badge badge-primary progressBtn">
                                  Progress
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 5 && (
                                <label className="badge badge-primary pauseBtn">
                                  Pause
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 6 && (
                                <label className="badge badge-primary progressBtn ">
                                  Progress
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 7 && (
                                <label className="badge badge-primary successBtn">
                                  Closed
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 9 && (
                                <label className="badge badge-primary pauseBtn">
                                  Canceled
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 10 && (
                                <label className="badge badge-primary pauseBtn">
                                  Cancel IR
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 11 && (
                                <label className="badge badge-primary pauseBtn">
                                  Cancel CR
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 12 && (
                                <label className="badge badge-primary pauseBtn">
                                  Cancel NR
                                </label>
                              )}

                              {job?.jobs?.[0]?.Note?.length > 0 &&
                                <div
                                  className="jobNotesBox"
                                  style={{
                                    position: "relative",
                                    top: "0",
                                    right: "50%",
                                    left: "34%",
                                  }}
                                >
                                  <span class="icon--inventory"></span>
                                  <div className="card card-body jobNotes">
                                    <p className="d-flex justify-content-between align-items-center">
                                      <span>{job?.jobs?.[0]?.Note}</span>


                                    </p>
                                  </div>
                                </div>
                              }



                            </td>

                            <td className='align-middle text-center' >
                              <span className='d-block mb-1'>
                                {job?.serviceProviderData?.Name || ''}

                              </span>
                              <a class="text-nowrap" href={`tel:${job?.serviceProviderData?.ContactNo}`}>
                                {job?.serviceProviderData?.Name && <i class="fas fa-phone"></i>}
                                {job?.serviceProviderData?.ContactNo}</a>
                              {/* <span className='d-block text-center'>
                            {job?.serviceProviderData?.ContactNo}

                          </span> */}

                            </td>
                            <td className='text-center align-middle'>
                              <p className='text-center m-0'>

                                {job?.jobs?.[0]?.slotDate}
                              </p>
                              <p className='badge badge-primary mb-1 font-fixd   ' >{job?.jobs?.[0]?.slotTime}</p>
                            </td>
                            <td className='align-middle text-center' style={{ whiteSpace: 'nowrap' }}>
                              {
                                job?.jobs?.[0]?.couponCode &&
                                <p
                                  className='badge badge-danger PauseBtn mb-4'
                                  style={{ backgroundColor: "red", fontSize: "12px" }}

                                >  {job?.jobs?.[0]?.couponCode}</p>
                              }

                              <p className='badge badge-success ml-1 mb-2  d-block' style={{ fontSize: '12px', }}> {ParentCategoryGroup?.find((item) => item._id === job?.jobs?.[0].cart?.[0]?.PCGroup)?.PCGName || job?.jobs?.[0].cart?.[0]?.PCGroup} </p>
                              {isGoldProfessionalJob(job?.jobs?.[0]) && (
                                <p className='badge badge-warning ml-1 mb-0 d-block' style={{ fontSize: '12px' }}>
                                  Gold Expert{getGoldProfessionalFee(job?.jobs?.[0]) > 0 ? ` (+₹${getGoldProfessionalFee(job?.jobs?.[0])})` : ""}
                                </p>
                              )}
                            </td>
                            <td className='align-middle text-center'>


                              <span class="d-block text-center">{job?.userData?.name}</span>
                              <span class="d-block text-center">{job?.userData?.email}</span>
                              <span class="d-block text-center"><a href="tel:9958887022" class="text-dark text-center"><i class="fa fa-phone mr-2"></i>{job?.userData?.mobileNo}</a></span>
                            </td>


                            <td className='align-middle text-center' style={{ minWidth: "200px" }} >
                              <div>
                                <a
                                  className="text-dark"
                                  href={
                                    job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress != null && job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress != "" ?
                                      `https://www.google.com/maps/search/?api=1&query=` + encodeURI(
                                        job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress
                                      ) : `https://www.google.com/maps?q=${job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.location?.latitude},${job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.location?.longitude}`}

                                  target="_blank"
                                >


                                  <span className='d-block text-center font-weight-bold '>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.SaveAs}</span>
                                  <span className='d-block text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.houseOrFlatNo}</span>

                                  <span className='d-block text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.buildingName}</span>
                                  <span className='d-block  text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.landmark}</span>

                                  <span className='d-block text-center'> <i class="fa fa-map-marker mr-2 display-inline-block"></i>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress}</span>
                                </a>
                              </div>
                            </td>
                            <td className='align-middle text-center'>


                              {
                                getTotalJobCount(job?.userData?._id) < 6 && (
                                  <span
                                    style={{
                                      backgroundColor:
                                        "#cbcfd6",
                                    }}
                                    className="badge badge-light mb-0 d-block"

                                  >Silver</span>
                                )
                              }
                              {
                                getTotalJobCount(job?.userData?._id) >= 6 && getTotalJobCount(job?.userData?._id) < 15 && (
                                  <span className="badge badge-info mb-2 d-block ">Diamond</span>
                                )
                              }
                              {
                                getTotalJobCount(job?.userData?._id) >= 15 && (
                                  <span className="badge badge-warning mb-2 d-block ">Gold</span>
                                )
                              }
                              <span className='d-flex   ' style={{ whiteSpace: 'nowrap', gap: "5px" }}>
                                <p>

                                  R. Count :
                                </p>
                                <p>

                                  {job?.jobs?.[0]?.updateLogs?.filter((itemDtaa) => itemDtaa?.action == "reschedule")?.length
                                  }
                                  <br></br>

                                </p>
                              </span>
                              <span className='d-flex   ' style={{ whiteSpace: 'nowrap', gap: "5px" }}>
                                <p>

                                  Job Count:
                                </p>
                                <p>

                                  {getTotalJobCount(job?.userData?._id)}
                                  <br></br>

                                </p>
                              </span>
                            </td>
                            <td className='align-middle ' style={{ whiteSpace: 'nowrap' }}>



                              {/* <Dropdown
                                options={[
                                  {
                                    value: 'editjob', label: (
                                      <span>
                                        <i className="fas fa-edit"></i> Edit Job
                                      </span>
                                    )
                                  },

                                  { value: 'assignsp', label: job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>) },
                                  { value: 'reschedule', label: <><i className="fa fa-user-edit mr-1"></i>Reschedule Job</> },
                                  { value: 'canceljob', label: job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null },
                                  { value: "start_journey", label: job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null },
                                  { value: "stop_journey", label: job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null },
                                  { value: "start_job", label: job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null },
                                  { value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null },
                                  { value: "resume_job", label: job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null },
                                  { value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null },
                                  { value: "close", label: job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null },
                                  { value: "reopen", label: job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null },
                                  { value: "duplicatejob", label: <span><i class="fas fa-clone"></i> Duplicate Job</span> }
                                ].filter(option => option.label)}
                                onChange={(e) => {
                                  handleDropdownChange(e, job?.jobs?.[0]?.jobId, job);
                                }}
                                placeholder="Action"
                                arrowClosed={<span className="arrow-closed" />}
                                arrowOpen={<span className="arrow-open" />}
                                style={{ whiteSpace: 'nowrap' }}
                              /> */}
                              <Dropdown>
                                <Dropdown.Toggle variant="transparent" id="dropdown-basic" className='border-1 border-dark'>
                                  Action
                                </Dropdown.Toggle>

                                <Dropdown.Menu>

                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({
                                      value: 'editjob', label: (
                                        <span>
                                          <i className="fas fa-edit"></i> Edit Job
                                        </span>
                                      )
                                    }, job?.jobs?.[0]?.jobId, job);
                                  }}  >
                                    <span>
                                      <i className="fas fa-edit"></i> Edit Job
                                    </span>

                                  </Dropdown.Item>

                                  {job?.jobs?.[0]?.jobStatus != 7 && (<Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'assignsp', label: job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>) }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>)} </Dropdown.Item>)}
                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'reschedule', label: <><i className="fa fa-user-edit mr-1"></i>Reschedule Job</> }, job?.jobs?.[0]?.jobId, job);
                                  }}> {<><i className="fa fa-user-edit mr-1"></i>Reschedule Job</>} </Dropdown.Item>
                                  {job?.jobs?.[0]?.jobStatus != 7 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'canceljob', label: job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 1 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "start_journey", label: job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 2 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "stop_journey", label: job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 3 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "start_job", label: job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 4 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 5 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "resume_job", label: job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 6 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "close", label: job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 7 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "reopen", label: job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null} </Dropdown.Item> : null}
                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "duplicatejob", label: <span><i class="fas fa-clone"></i> Duplicate Job</span> }, job?.jobs?.[0]?.jobId, job);
                                  }}> {<span><i class="fas fa-clone"></i> Duplicate Job</span>} </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>

                            </td>
                          </tr>
                        ))}
                        <tr>
                          <p className="m-0 p-2 text-primary font-weight-bold">Evening</p>
                        </tr>
                        {categorizedJobs["evening"]?.map((job, index) => (
                          <tr key={job._id}  >
                            <td style={{ cursor: "pointer" }} onClick={() => window.open(`/jobdetails/${job?.jobs?.[0]?.jobId}`)}>{(categorizedJobs["morning"].length + categorizedJobs["afternoon"].length) + index + 1}</td>
                            <td className='text-center align-middle' >
                              <span className="d-block mb-1 jobID fs-6 text-primary relative" style={{ fontSize: "16px", letterSpacing: "1px", cursor: " pointer" }} onClick={() => window.open(`/jobdetails/${job?.jobs?.[0]?.jobId}`)}>
                                {job?.jobs?.[0]?.jobId}

                                {
                                  job?.jobs?.[0]?.cart?.[0]?.packageName?.length > 0 ?
                                    <span className="package-name" >
                                      {job?.jobs?.[0]?.cart?.map((item, index) => {
                                        return (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                              <span
                                                style={{
                                                  fontSize: "15px",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                {item?.packageTitle}
                                              </span>
                                              <ul
                                                className="ml-1"
                                                style={{
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {item?.packageName &&
                                                  item?.packageName.map(
                                                    (item, index) => {
                                                      return (
                                                        <li className="mb-0">
                                                          {item}
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                              </ul>
                                            </td>
                                            <td>{item?.Quantity}</td>
                                            <td>
                                              ₹ {item?.packagetotalPrice}
                                            </td>
                                            <td>₹ {item?.Amount}</td>
                                          </tr>
                                        );
                                      })}
                                    </span>
                                    :
                                    <span className="package-name" >
                                      {job?.jobs?.[0]?.cart?.map((item, index) => {
                                        return (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                              <span
                                                style={{
                                                  fontSize: "15px",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                {item?.packageTitle}
                                              </span>
                                              <ul
                                                className="ml-1"
                                                style={{
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {item?.packageName &&
                                                  item?.packageName.map(
                                                    (item, index) => {
                                                      return (
                                                        <li className="mb-0">
                                                          {item}
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                              </ul>
                                            </td>
                                            <td>{item?.Quantity}</td>
                                            <td>
                                              ₹ {item?.packagetotalPrice}
                                            </td>
                                            <td>₹ {item?.Amount}</td>
                                          </tr>
                                        );
                                      })}
                                    </span>

                                }
                              </span>

                              {job?.jobs?.[0]?.jobStatus == 0 && (
                                <label className="badge badge-primary">
                                  Schedule
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 1 && (
                                <label className="badge badge-primary">
                                  Open
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 2 && (
                                <label className="badge badge-warning">
                                  Start Journey
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 3 && (
                                <label className="badge badge-warning">
                                  Stop Journey
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 4 && (
                                <label className="badge badge-primary progressBtn">
                                  Progress
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 5 && (
                                <label className="badge badge-primary pauseBtn">
                                  Pause
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 6 && (
                                <label className="badge badge-primary progressBtn ">
                                  Progress
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 7 && (
                                <label className="badge badge-primary successBtn">
                                  Closed
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 9 && (
                                <label className="badge badge-primary pauseBtn">
                                  Canceled
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 10 && (
                                <label className="badge badge-primary pauseBtn">
                                  Cancel IR
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 11 && (
                                <label className="badge badge-primary pauseBtn">
                                  Cancel CR
                                </label>
                              )}
                              {job?.jobs?.[0]?.jobStatus == 12 && (
                                <label className="badge badge-primary pauseBtn">
                                  Cancel NR
                                </label>
                              )}

                              {job?.jobs?.[0]?.Note?.length > 0 &&
                                <div
                                  className="jobNotesBox"
                                  style={{
                                    position: "relative",
                                    top: "0",
                                    right: "50%",
                                    left: "34%",
                                  }}
                                >
                                  <span class="icon--inventory"></span>
                                  <div className="card card-body jobNotes">
                                    <p className="d-flex justify-content-between align-items-center">
                                      <span>{job?.jobs?.[0]?.Note}</span>


                                    </p>
                                  </div>
                                </div>
                              }



                            </td>

                            <td className='align-middle text-center' >
                              <span className='d-block mb-1'>
                                {job?.serviceProviderData?.Name || ''}

                              </span>
                              <a class="text-nowrap" href={`tel:${job?.serviceProviderData?.ContactNo}`}>
                                {job?.serviceProviderData?.Name && <i class="fas fa-phone"></i>}

                                {job?.serviceProviderData?.ContactNo}</a>
                              {/* <span className='d-block text-center'>
                            {job?.serviceProviderData?.ContactNo}

                          </span> */}

                            </td>
                            <td className='text-center align-middle'>
                              <p className='text-center m-0'>

                                {job?.jobs?.[0]?.slotDate}
                              </p>
                              <p className='badge badge-primary mb-1 font-fixd   ' >{job?.jobs?.[0]?.slotTime}</p>
                            </td>
                            <td className='align-middle text-center' style={{ whiteSpace: 'nowrap' }}>
                              {
                                job?.jobs?.[0]?.couponCode &&
                                <p
                                  className='badge badge-danger PauseBtn mb-4'
                                  style={{ backgroundColor: "red", fontSize: "12px" }}

                                >  {job?.jobs?.[0]?.couponCode}</p>
                              }

                              <p className='badge badge-success ml-1 mb-2  d-block' style={{ fontSize: '12px', }}> {ParentCategoryGroup?.find((item) => item._id === job?.jobs?.[0].cart?.[0]?.PCGroup)?.PCGName || job?.jobs?.[0].cart?.[0]?.PCGroup} </p>
                              {isGoldProfessionalJob(job?.jobs?.[0]) && (
                                <p className='badge badge-warning ml-1 mb-0 d-block' style={{ fontSize: '12px' }}>
                                  Gold Expert{getGoldProfessionalFee(job?.jobs?.[0]) > 0 ? ` (+₹${getGoldProfessionalFee(job?.jobs?.[0])})` : ""}
                                </p>
                              )}
                            </td>
                            <td className='align-middle text-center'>


                              <span class="d-block text-center">{job?.userData?.name}</span>
                              <span class="d-block text-center">{job?.userData?.email}</span>
                              <span class="d-block text-center"><a href="tel:9958887022" class="text-dark text-center"><i class="fa fa-phone mr-2"></i>{job?.userData?.mobileNo}</a></span>
                            </td>


                            <td className='align-middle text-center' >
                              <div>
                                <a
                                  className="text-dark"
                                  href={
                                    job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress != null && job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress != "" ?
                                      `https://www.google.com/maps/search/?api=1&query=` + encodeURI(
                                        job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress
                                      ) : `https://www.google.com/maps?q=${job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.location?.latitude},${job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.location?.longitude}`}

                                  target="_blank"
                                >


                                  <span className='d-block text-center font-weight-bold '>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.SaveAs}</span>
                                  <span className='d-block text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.houseOrFlatNo}</span>

                                  <span className='d-block text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.buildingName}</span>
                                  <span className='d-block  text-center'>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.landmark}</span>

                                  <span className='d-block text-center'> <i class="fa fa-map-marker mr-2 display-inline-block"></i>{job?.jobs?.[0]?.userData?.address?.find((item) => item._id == job?.jobs?.[0]?.clientAddressId)?.FullAddress}</span>
                                </a>
                              </div>
                            </td>
                            <td className='align-middle text-center'>


                              {
                                getTotalJobCount(job?.userData?._id) < 6 && (
                                  <span
                                    style={{
                                      backgroundColor:
                                        "#cbcfd6",
                                    }}
                                    className="badge badge-light mb-0 d-block"

                                  >Silver</span>
                                )
                              }
                              {
                                getTotalJobCount(job?.userData?._id) >= 6 && getTotalJobCount(job?.userData?._id) < 15 && (
                                  <span className="badge badge-info mb-2 d-block ">Diamond</span>
                                )
                              }
                              {
                                getTotalJobCount(job?.userData?._id) >= 15 && (
                                  <span className="badge badge-warning mb-2 d-block ">Gold</span>
                                )
                              }
                              <span className='d-flex   ' style={{ whiteSpace: 'nowrap', gap: "5px" }}>
                                <p>

                                  R. Count :
                                </p>
                                <p>

                                  {job?.jobs?.[0]?.updateLogs?.filter((itemDtaa) => itemDtaa?.action == "reschedule")?.length
                                  }
                                  <br></br>

                                </p>
                              </span>

                              <span className='d-flex   ' style={{ whiteSpace: 'nowrap', gap: "5px" }}>
                                <p>

                                  Job Count:
                                </p>
                                <p>

                                  {getTotalJobCount(job?.userData?._id)}
                                  <br></br>

                                </p>
                              </span>
                            </td>
                            <td className='align-middle ' style={{ whiteSpace: 'nowrap' }}>



                              {/* <Dropdown
                                options={[
                                  {
                                    value: 'editjob', label: (
                                      <span>
                                        <i className="fas fa-edit"></i> Edit Job
                                      </span>
                                    )
                                  },

                                  { value: 'assignsp', label: job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>) },
                                  { value: 'reschedule', label: <><i className="fa fa-user-edit mr-1"></i>Reschedule Job</> },
                                  { value: 'canceljob', label: job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null },
                                  { value: "start_journey", label: job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null },
                                  { value: "stop_journey", label: job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null },
                                  { value: "start_job", label: job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null },
                                  { value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null },
                                  { value: "resume_job", label: job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null },
                                  { value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null },
                                  { value: "close", label: job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null },
                                  { value: "reopen", label: job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null },
                                  { value: "duplicatejob", label: <span><i class="fas fa-clone"></i> Duplicate Job</span> }
                                ].filter(option => option.label)}
                                onChange={(e) => {
                                  handleDropdownChange(e, job?.jobs?.[0]?.jobId, job);
                                }}
                                placeholder="Action"
                                arrowClosed={<span className="arrow-closed" />}
                                arrowOpen={<span className="arrow-open" />}
                                style={{ whiteSpace: 'nowrap' }}
                              /> */}

                              <Dropdown>
                                <Dropdown.Toggle variant="transparent" id="dropdown-basic" className='border-1 border-dark'>
                                  Action
                                </Dropdown.Toggle>

                                <Dropdown.Menu>

                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({
                                      value: 'editjob', label: (
                                        <span>
                                          <i className="fas fa-edit"></i> Edit Job
                                        </span>
                                      )
                                    }, job?.jobs?.[0]?.jobId, job);
                                  }}  >
                                    <span>
                                      <i className="fas fa-edit"></i> Edit Job
                                    </span>

                                  </Dropdown.Item>

                                  {job?.jobs?.[0]?.jobStatus != 7 && (<Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'assignsp', label: job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>) }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus != 7 && (job?.jobs?.[0]?.jobStatus === 0 ? <span><i className="fas fa-bullseye"></i> Assign SP</span> : <span><i className="fas fa-bullseye"></i> Reassign SP</span>)} </Dropdown.Item>)}
                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'reschedule', label: <><i className="fa fa-user-edit mr-1"></i>Reschedule Job</> }, job?.jobs?.[0]?.jobId, job);
                                  }}> {<><i className="fa fa-user-edit mr-1"></i>Reschedule Job</>} </Dropdown.Item>
                                  {job?.jobs?.[0]?.jobStatus != 7 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: 'canceljob', label: job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> 
                                  
                                  {job?.jobs?.[0]?.jobStatus != 7 ? <><i className="fas fa-window-close mr-1"></i>Cancel Job</> : null} </Dropdown.Item> : null}


                                  
                                  {job?.jobs?.[0]?.jobStatus === 1 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "start_journey", label: job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 1 ? <><i className="fas fa-bullseye mr-1"></i>Start Journey</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 2 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "stop_journey", label: job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 2 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 3 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "start_job", label: job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 3 ? <><i className="fas fa-play-circle mr-1"></i> 'Start Job'</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 4 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 4 ? <><i className="fas fa-pause-circle mr-1"></i>Stop Journey</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 5 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "resume_job", label: job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 5 ? <><i className="fas fa-play-circle mr-1"></i>Resume Job</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 6 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "stop_job", label: job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 6 ? <><i className="fas fa-pause-circle mr-1"></i>Pause Job</> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "close", label: job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus != 0 && job?.jobs?.[0]?.jobStatus != 7 ? <span><i className="fas fa-ban mr-1"></i>Close</span> : null} </Dropdown.Item> : null}
                                  {job?.jobs?.[0]?.jobStatus === 7 ? <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "reopen", label: job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null }, job?.jobs?.[0]?.jobId, job);
                                  }}> {job?.jobs?.[0]?.jobStatus === 7 ? <span><i className="fas fa-lock-open"></i>Reopen</span> : null} </Dropdown.Item> : null}
                                  <Dropdown.Item onClick={() => {
                                    handleDropdownChange({ value: "duplicatejob", label: <span><i class="fas fa-clone"></i> Duplicate Job</span> }, job?.jobs?.[0]?.jobId, job);
                                  }}> {<span><i class="fas fa-clone"></i> Duplicate Job</span>} </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))}
                        </>
                      )}
                      </tbody>
                    </table>
                  </>

                }



              </div>
            </div>




            <div className='pb-3'>

              {
                filteredJobs.length != 0 && (
                  DayFilter == false && (
                    <div className="d-flex justify-content-center align-items-center">
                      <div className="text-center">
                        {totalPages > 1 && (
                          <div>
                            <button
                              className="btn btn-sm btn-primary me-2"
                              onClick={handlePrevGroup}
                              disabled={pageGroup === 0}
                            >
                              Previous
                            </button>

                            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                              <button
                                key={startPage + i}
                                className={`btn btn-sm mx-1 ${currentPage === startPage + i ? 'btn-primary' : 'btn-transparent  btn-outline-primary'}`}
                                onClick={() => handlePageClick(startPage + i)}
                              >
                                {startPage + i}
                              </button>
                            ))}

                            <button
                              className="btn btn-sm btn-primary ms-2"
                              onClick={handleNextGroup}
                              disabled={endPage >= totalPages}
                            >
                              Next
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                )
              }
            </div>


            {/* Pagination */}


        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel={
            Modellebal.label
          }
        >

          <div className='d-flex justify-content-between align-items-center'>
            <h3>{JobLabel}</h3>
            <button className="btn " onClick={closeAllModal}><IoMdClose />
            </button>
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="select">Select SP</label>
            <select
              className="form-control"
              id="select"
              // value={assignJobsdata?.jobAssignSProviderId}
              onChange={(e) => {
                const selectedIndex = e.target.selectedIndex;
                const selectedOption = e.target.options[selectedIndex];

                setassignJobsdata({
                  ...assignJobsdata,
                  jobAssignSProviderId: e.target.value,
                  SPName: selectedOption.getAttribute("data-name"),
                });
              }}
            >
              <option value="">Select SP</option>
              {AllSp?.map((item) => (
                <option key={item._id} value={item._id} data-name={item.Name}>
                  {item.Name} ({item?.expertType === "gold" ? "Gold Expert" : "Prime Expert"})
                </option>
              ))}
            </select>

          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="message">Message</label>
            <textarea className="form-control" id="message" rows="3"
              value={assignJobsdata?.reasons}
              onChange={(e) => {
                setassignJobsdata({
                  ...assignJobsdata,
                  reasons: e.target.value
                })
              }}
            ></textarea>
          </div>

          <div>
            <button className="btn btn-warning" onClick={closeModal}>Close</button>
            <button className="btn btn-primary mx-2"
              onClick={() => {
                updateJobAssignment()
              }}
            >{Modellebal.label}</button>
          </div>

        </Modal>
        <Modal
          isOpen={isModalOpen2}
          onRequestClose={() => setIsModalOpen2(false)}
          style={customStylesRes}
          contentLabel={
            Modellebal.label
          }
        >

          <div className='d-flex justify-content-between align-items-center'>
            <h3>{JobLabel}</h3>
            <button className="btn " onClick={closeAllModal}><IoMdClose />
            </button>
          </div>
          <form>
            <div className="form-group">
              <label className="control-label" htmlFor="date">Select Slot (date)</label>
              <input type="date" className="form-control" id="date" value={selectSlot} onChange={(e) => { setselectSlot(e.target.value); fetchSlots(e.target.value, slectedJob?.jobs?.[0]?.cart?.[0]?.PCGroup); setassignJobsdata({ ...assignJobsdata, slotDate: e.target.value }); }} />
            </div>

            <div className="d-flex flex-wrap mb-3" style={{ gap: "10px" }}>

              {
                SlotData?.[0]?.slot?.map((item) => {
                  const [startTime, endTime] = item?.slotTime?.split('-');
                  const formattedStartTime = startTime?.replace(/AM|PM/g, '').trim();
                  const formattedTime = `${formattedStartTime}-${endTime?.trim()}`;
                  return <div className={`btn rounded btn-sm ${SectTime === formattedTime ? "btn-primary" : "btn-outline-primary"}`} onClick={() => { setSectTime(formattedTime); setassignJobsdata({ ...assignJobsdata, slotTime: formattedTime }) }} >{formattedTime}</div>
                })
              }
            </div>

            <div className="form-group">
              <label className="control-label" htmlFor="select">Select SP</label>
              <select className="form-control" id="select"
                // value={assignJobsdata?.jobAssignSProviderId}
                onChange={(e) => {
                  setassignJobsdata({ ...assignJobsdata, jobAssignSProviderId: e.target.value })
                }}
              >
                <option value="">Select SP</option>
                {
                  AllSp?.map((item) => {
                    return <option key={item._id} value={item._id}>{item.Name} ({item?.expertType === "gold" ? "Gold Expert" : "Prime Expert"})</option>
                  })
                }
              </select>
            </div>

            <div className="form-group">
              <label className="control-label" htmlFor="comment">Reasons</label>
              <textarea className="form-control" id="comment" rows="3"
                value={assignJobsdata?.reasons}
                onChange={(e) => {
                  setassignJobsdata({ ...assignJobsdata, reasons: e.target.value })
                }}
              ></textarea>
            </div>
          </form>


          <div className="modal-footer justify-content-start">
            <button className="btn btn-warning" onClick={() => { setIsModalOpen2(false) }}>No</button>
            <button className="btn btn-primary"
              onClick={() => { updateJobAssignment() }}

            >Reshedule</button>
          </div>

        </Modal>


        <Modal
          isOpen={isModalOpen3}
          onRequestClose={() => setIsModalOpen3(false)}
          style={customStyles}
          contentLabel={
            Modellebal.label
          }

        >

          <div className='d-flex justify-content-between align-items-center'>
            <h3>{JobLabel}</h3>
            <button className="btn " onClick={closeAllModal}><IoMdClose />
            </button>
          </div>
          <form id="cancel_job" className="needs-validation" novalidate>
            <div className="form-group">
              <label>Select Type</label>
              <select
                className="form-control"
                name="cmbCancelState"
                id="cmbCancelState"
                required
                value={assignJobsdata?.action}
                onChange={(e) => {
                  setassignJobsdata({ ...assignJobsdata, action: e.target.value })
                }}
              >
                <option value="">Select</option>
                <option value="canceled">Canceled</option>
                <option value="cancel_IR">Canceled IR</option>
                <option value="cancel_CR">Canceled CR</option>
                <option value="cancel_NR">Canceled NR</option>
              </select>
            </div>
            <div className="form-group">
              <label>Comment</label>
              <textarea
                className="form-control"
                name="CancelComment"
                id="CancelComment"
                placeholder="Add Comment"
                rows="4"
              ></textarea>
            </div>
          </form>



          <div className="modal-footer justify-content-start">
            <button className="btn btn-warning" onClick={() => { setIsModalOpen3(false) }}>No</button>
            <button className="btn btn-primary" onClick={() => { updateJobAssignment() }}>Cancel</button>
          </div>

        </Modal>

        <Modal
          isOpen={isModalOpen4}
          onRequestClose={() => setIsModalOpen4(false)}
          style={customStyles2}
          contentLabel={
            Modellebal.label
          }
        >

          <div className='d-flex justify-content-between align-items-center'>
            <h3>{JobLabel}</h3>
            <button className="btn " onClick={closeAllModal}><IoMdClose />
            </button>
          </div>




          <div className="modal-footer justify-content-start">
            <button className="btn btn-warning" onClick={() => { setIsModalOpen4(false) }}>No</button>
            <button className="btn btn-primary" onClick={() => { updateJobAssignment() }}>Yes</button>
          </div>

        </Modal>
        <Modal
          isOpen={isModalOpen5}
          onRequestClose={() => setIsModalOpen5(false)}
          style={customStyles}
          contentLabel={
            Modellebal.label
          }
        >

          <div className='d-flex justify-content-between align-items-center'>
            <h3>{JobLabel}</h3>
            <button className="btn " onClick={closeAllModal}><IoMdClose />
            </button>
          </div>



          <div className="form-group">
            <label>Amount</label>
            <input type="number" className="form-control" name="CloseJobAmount" id="CloseJobAmount" placeholder="Enter Amount"
              onChange={(e) => { setassignJobsdata({ ...assignJobsdata, payableCharges: e.target.value }) }}
              value={assignJobsdata?.payableCharges}

            />
          </div>
          <div className="form-group">
            <label>Tip</label>
            <input type="number" className="form-control" name="CloseJobTip" id="CloseJobTip" placeholder="Enter Tip"
              onChange={(e) => { setassignJobsdata({ ...assignJobsdata, tip: e.target.value }) }}
              value={assignJobsdata?.tip}
            />
          </div>
          <div className="form-group">
            <label>Payment Mode</label>
            <select className="form-control" name="CloseJobPaymentMode" id="CloseJobPaymentMode"
              onChange={(e) => { setassignJobsdata({ ...assignJobsdata, payment_Mode: e.target.value }) }}
              value={assignJobsdata?.payment_Mode}
            >
              <option value="">Select</option>
              <option value="CARD">CARD</option>
              <option value="CASH">CASH</option>
              <option value="PAYTM">PAYTM</option>
              <option value="GOOGLEPAY">GOOGLEPAY</option>
              <option value="PHONEPAY">PHONEPAY</option>
            </select>
          </div>
          <div className="form-group">
            <label>Comment</label>
            <textarea className="form-control" name="CloseJobComment" id="CloseJobComment" placeholder="Add Comment" rows="4"
              onChange={(e) => { setassignJobsdata({ ...assignJobsdata, reasons: e.target.value }) }}
              value={assignJobsdata?.reasons}

            ></textarea>
          </div>


          <div className="modal-footer justify-content-start">
            <button className="btn btn-warning" onClick={() => { setIsModalOpen5(false) }}>No</button>
            <button className="btn btn-primary" onClick={() => { updateJobAssignment() }}>Close</button>
          </div>

        </Modal>
      </div>
    </div>
  )
}

export default TodayJobs